import heading from '@/constants/elements/heading';
import textBlock from '@/constants/elements/text-block';
import button from '@/constants/elements/button';
import textField from '@/constants/elements/text-field';
import emailField from '@/constants/elements/email-field';
import textArea from '@/constants/elements/text-area';
import dropdown from '@/constants/elements/dropdown';
import checkbox from '@/constants/elements/checkbox';
import submitButton from '@/constants/elements/submit-button';

type ELEMENT_INFO = {
  defaultClass: string;
  settingGroups: {
    [key: string]: {
      [key: string]: {
        selector: string;
        inherit?: string; // (subType|type).key
        cssAttr?: string;
        listUnit?: string;
      };
    };
  };
};

export const ELEMENTS_MAP: Record<any, ELEMENT_INFO> = {
  heading: heading,
  'text-block': textBlock,
  button: button,
  'text-field': textField,
  'email-field': emailField,
  'text-area': textArea,
  dropdown: dropdown,
  checkbox: checkbox,
  'submit-button': submitButton,
};

type DESIGN_GROUP_INFO = {
  [key: string]: {
    [key: string]: {
      selector?: string;
      inherit?: string; // (subType|type).key
      cssAttr?: string;
      listUnit?: string;
    };
  };
};

export const DESIGN_GROUP: DESIGN_GROUP_INFO = {
  'gs-border': {
    'border-style': {
      inherit: 'border.style',
      cssAttr: 'border-style',
    },
    'border-color': {
      inherit: 'border.color',
      cssAttr: 'border-color',
    },
    'border-width': {
      inherit: 'border.thickness',
      cssAttr: 'border-width',
    },
    'border-top-width': {
      inherit: 'border.thickness',
      cssAttr: 'border-top-width',
    },
    'border-right-width': {
      inherit: 'border.thickness',
      cssAttr: 'border-right-width',
    },
    'border-bottom-width': {
      inherit: 'border.thickness',
      cssAttr: 'border-bottom-width',
    },
    'border-left-width': {
      inherit: 'border.thickness',
      cssAttr: 'border-left-width',
    },
  },
  'gs-corner': {
    'border-top-left-radius': {
      inherit: 'corner.top',
      cssAttr: 'border-top-left-radius',
    },
    'border-top-right-radius': {
      inherit: 'corner.right',
      cssAttr: 'border-top-right-radius',
    },
    'border-bottom-right-radius': {
      inherit: 'corner.bottom',
      cssAttr: 'border-bottom-right-radius',
    },
    'border-bottom-left-radius': {
      inherit: 'corner.left',
      cssAttr: 'border-bottom-left-radius',
    },
  },
  'gs-spacing': {
    'margin-top': {
      selector: '#{eID}',
      inherit: 'spacing.margin-top',
      cssAttr: 'margin-top',
    },
    'margin-right': {
      selector: '#{eID}',
      inherit: 'spacing.margin-right',
      cssAttr: 'margin-right',
    },
    'margin-bottom': {
      selector: '#{eID}',
      inherit: 'spacing.margin-bottom',
      cssAttr: 'margin-bottom',
    },
    'margin-left': {
      selector: '#{eID}',
      inherit: 'spacing.margin-left',
      cssAttr: 'margin-left',
    },
    'padding-top': {
      inherit: 'spacing.padding-top',
      cssAttr: 'padding-top',
    },
    'padding-right': {
      inherit: 'spacing.padding-right',
      cssAttr: 'padding-right',
    },
    'padding-bottom': {
      inherit: 'spacing.padding-bottom',
      cssAttr: 'padding-bottom',
    },
    'padding-left': {
      inherit: 'spacing.padding-left',
      cssAttr: 'padding-left',
    },
  },
  independent: {
    'background-color': {
      inherit: 'color.neutrals.color2',
      cssAttr: 'background-color',
    },
  },
};

export const replaceMap = (str: string, eID: string, titleTag: string) => {
  if (!str) {
    return str;
  }
  return str.replace('#{eID}', eID).replace('#{mID}', eID).replace('#{rID}', eID).replace('#{titleTag}', titleTag);
};
